module.exports = __webpack_public_path__ + "img/cw_selected.9de372a5.png";